<template>
  <div>
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="mx-auto container-xl mb-5">
      <div class="">
        <div class="title-area">
          <h1 class="page-title h2 mb-5">
            My aggregated reports
          </h1>
        </div>
      </div>
      <div class="survey-table">
        <b-modal v-model="wipeconfirm" hide-footer title="Delete survey permanently?">
          <p v-if="wipereports.length > 0">
            Are you sure you want to delete these reports?
            <ul class="mt-3">
              <li v-for="report in wipereports" class="mb-1">{{ report.name }} ({{ report.id }})</li>
            </ul>
          </p>
          <b-button class="mt-3" variant="danger" block @click="delete_many()">
            Delete
          </b-button>
          <b-button class="mt-2" variant="secondary" block @click="wipeconfirm = false; wipesurvey = false;">
            Cancel
          </b-button>
        </b-modal>
        <b-modal v-model="wipeprogress" hide-footer title="Permanently deleting reports">
          <b-row>
            <div class="col-12 text-center">
              <h5>Deleting reports</h5>
            </div>
          </b-row>
          <div class="col-12 text-center">
            <b-spinner style="width: 4rem; height: 4rem;" variant="danger"></b-spinner>
          </div>
        </b-modal>
        <div class="table-filter-area">
          <div>
            <b-form-group>
              <b-input type="text" v-model="search" @input="handleSearch" placeholder="Search" />
            </b-form-group>
          </div>
          <div class="table-button-area mb-3">
            <div class="d-flex justify-content-end">
              <div>
                <button class="btn btn-small btn-secondary" @click="clearFilters">Clear filter</button>
                <button class="btn btn-small btn-secondary" @click.prevent="wipeconfirm = true"
                  :disabled="wipereports.length === 0">
                  Delete
                </button>
              </div>
            </div>
          </div>

        </div>

        <b-table responsive hover :busy="loading" :items="reports" :fields="fields" class="table surveytable"
          @row-clicked="report_download">

          <template v-slot:head(select)>
            <b-form-checkbox :checked="allSelected" @change="selectall($event)" />
          </template>

          <template v-slot:cell(select)="data">
            <div>
              <b-form-checkbox v-model="data.item.selected" @change="countselected" />
            </div>
          </template>

          <template #table-busy>
            <div class="text-center text-success my-2">
              <b-spinner class="align-middle mr-2" />
              <strong>Loading...</strong>
            </div>
          </template>

          <template v-slot:cell(id)="data">
            {{ data.item.id }}
          </template>

          <template v-slot:cell(report_name)="data">
            <span :class="`${anon ? 'g-anon' : ''}`">
              <i class="fa fa-regular fa-file-chart-column"></i>&nbsp;&nbsp;{{ data.item.report_name }}
            </span>
          </template>

          <template v-slot:cell(report_date)="data">
            {{ format_date(data.item.report_date) }}
          </template>

          <template v-slot:cell(survey_type)="data">
            {{ data.item.survey_type }}
          </template>

          <template v-slot:cell(normvalues_id)="data">
            {{ normvalues_country_name(data.item.normvalues_id) }}
          </template>

          <template v-slot:cell(language_id)="data">
            <lang-flag :iso="flag_code(data.item.language_id)" :squared="false" />{{ data.item.language_id }}
          </template>

          <template v-slot:cell(actions)="data">
            <b-dropdown right class="w-100">
              <template #button-content>
                <i class="fa-solid fa-ellipsis"></i>
              </template>
              <b-dropdown-item @click.prevent="report_download_file(data.item.id)">Download</b-dropdown-item>
              <b-dropdown-item @click.prevent="record_delete_confirm(data.item.id)">
                Delete
              </b-dropdown-item>
            </b-dropdown>
          </template>

        </b-table>
      </div>
    </div>
  </div>
</template>
<script>
import Breadcrumb from '../Breadcrumb.vue'
import Navbar from '../Navbar.vue'
import LangFlag from 'vue-lang-code-flags'
import { config } from '../../../config'

export default {
  components: {
    LangFlag,
    Navbar,
    Breadcrumb
  },
  data () {
    return {
      reports: [],
      wipeconfirm: false,
      wipeprogress: false,
      allSelected: false,
      fields: [
        { key: 'select', label: 'S', sortable: false, tdClass: 'select-td', thClass: 'select-th' },
        { key: 'id', label: 'ID', sortable: false },
        { key: 'report_name', sortable: true, label: 'Report name', tdClass: 'w-50' },
        { key: 'report_date', sortable: true, label: 'Date' },
        { key: 'survey_type', sortable: true, label: 'Survey type' },
        { key: 'normvalues_id', sortable: true, label: 'Norm' },
        { key: 'language_id', sortable: true, label: 'Language' },
        { key: 'actions', label: 'Actions', class: 'ellipsis-button' }
      ],
      search: '',
      wipereports: [],
      visible: this.$store.state.mypage_reports_open,
      deleteshow: false,
      currentPage: 1,
      perPage: 25,
      retrieved: 0,
      languages: [],
      loading: true,
      rows: 0,
      orderby: 'report_date',
      orderdesc: true,
      normvalues_countries: this.$store.state.normvalues_countries
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    },
    mygdqpage_reload: {
      get () {
        return this.$store.state.mygdqpage_reload
      }
    },
    setadmin_done: {
      get () {
        return this.$store.state.questionnaire_admin_done
      }
    },
    groups: {
      get () {
        var items = this.$store.state.groups.filter(f => f.group_deleted == 0)
        var groups = [{
          value: null,
          text: 'Select group',
          disabled: true
        }]
        for (var i = 0; i < items.length; i++) {
          var option = {
            value: items[i].id,
            text: items[i].group_name
          }
          groups.push(option)
        }
        return groups
      },
      set () {
        return true
      }
    }
  },
  watch: {
  },
  created () {
    this.loading = true
    this.normvalues_countries_get()
    this.languages_get()
    this.reports_get()
  },
  methods: {
    clearFilters () {
      this.search = ''
      this.allSelected = false
      this.reports_get()
    },

    handleSearch () {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.reports_get()
      }, 1000)
    },

    filter_table (status_id) {
      this.allSelected = false
      this.reports_get()
    },

    selectall (event) {
      this.allSelected = event
      this.reports.forEach(report => {
        report.selected = this.allSelected
      })
      this.countselected()
    },

    countselected () {
      var selectedreports = []
      var numbersel = 0
      for (var i = 0; i < this.reports.length; i++) {
        if (this.reports[i].selected) {
          selectedreports.push({ id: this.reports[i].id, name: this.reports[i].report_name })
          numbersel++
        }
      }
      this.reportsselected = numbersel
      this.wipereports = selectedreports
    },

    languages_get () {
      this.$store.dispatch('languages_fetch')
        .then((resp) => {
          this.languages = resp.data.result.map(l => {
            return {
              value: l.id,
              text: l.language_name,
              code: l.language_code
            }
          })
        })
    },
    format_date (date) {
      var d = new Date(date)
      var month = '' + (d.getMonth() + 1)
      var day = '' + d.getDate()
      var year = d.getFullYear()
      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
      return [year, month, day].join('-')
    },
    flag_code: function (name) {
      var flag_code = ''
      for (var i = 0; i < this.languages.length; i++) {
        if (this.languages[i].text == name) {
          flag_code = this.languages[i].code
          break
        }
      }
      return flag_code
    },
    normvalues_country_name: function (norm_id) {
      var normvalues_country_name = ''
      for (var i = 0; i < this.normvalues_countries.length; i++) {
        if (this.normvalues_countries[i].country_id == norm_id) {
          normvalues_country_name = this.normvalues_countries[i].country_name
        }
      }
      return normvalues_country_name
    },
    normvalues_countries_get: function () {
      let survey_type_id = 1
      this.$store.dispatch('normvalues_countries_fetch')
        .then((resp) => {
          var options = []
          options.push({ value: 0, text: 'Please select norm values' })
          for (var i = 0; i < resp.data.length; i++) {
            if (resp.data[i].country_id == 999 || survey_type_id == 1) {
              var option = {
                value: resp.data[i].country_id,
                text: resp.data[i].country_name
              }
              options.push(option)
            }
          }
          this.norm_values_options = options
        })
    },
    data_sort (context) {
      this.orderby = context.sortBy
      this.orderdesc = context.sortDesc
      this.currentPage = 1
      this.reports_get()
    },
    setvisible: function () {
      this.visible = !this.visible
      this.$store.dispatch('setagreportsopen', this.visible)
    },
    record_delete_confirm (id) {
      let deleting = false
      if (confirm('Are you sure you want to delete this report?')) {
        deleting = true
      } else {
        deleting = false
      }

      if (deleting) {
        this.record_delete(id)
        this.reports_get()
      }
    },
    delete_many () {
      this.wipereports.forEach((item) => {
        this.record_delete(item.id)
      })
      this.wipereports = []
      this.wipeprogress = false
      this.wipeconfirm = false
      this.reports_get()
    },
    record_delete (id) {
      this.$store.dispatch('record_delete', {
        table_name: 'g_agreports',
        id: id
      })
    },
    record_delete_cancel () {
      this.deleteshow = false
    },
    reports_get: function () {
      this.loading = true
      this.$store
        .dispatch('aggregatedreports_get', {
          user_id: this.$store.state.user_id,
          start: (this.currentPage - 1) * this.perPage,
          limit: this.perPage,
          orderby: this.orderby,
          filter: {
            report_name: { operator: 'LIKE', value: `*${this.search}*` }
          },
          order: (this.orderdesc ? 'DESC' : 'ASC')
        })
        .then(result => {
          let reports = result.data.result
          this.retrieved = result.data.result.length
          this.rows = result.data.total
          this.reports = reports
          this.loading = false
        })
    },
    report_download_file (report_id) {
      var reporturl = config.report_url + '/gdq_agreport.php?r=' + report_id
      var downloadURL = new URL(reporturl)
      var downloadLink = document.createElement('a')
      downloadLink.href = downloadURL
      downloadLink.setAttribute('download', 'GDQ_AGReport_' + new Date().toISOString().split('T')[0])
      document.body.appendChild(downloadLink)
      downloadLink.click()
    },
    report_download (item, index, event) {
      const element = event.target
      const includedTags = ['span', 'i']

      if (includedTags.includes(element.tagName.toLowerCase())) {
        this.$store.dispatch('setcurrentaggregatedreport_id', { report_id: item.id })
          .then(() => {
            this.$router.push('/aggregatedreports')
          })
      }

      const isFirstElement = !element.previousSibling
      const isLastElement = !element.nextSibling

      if (!isLastElement && !isFirstElement) {
        this.$store.dispatch('setcurrentaggregatedreport_id', { report_id: item.id })
          .then(() => {
            this.$router.push('/aggregatedreports')
          })
      }
    }
  }
}
</script>
<style>
td {
  cursor: pointer !important;
}
</style>
